export interface IGuiaClienteReferencia {
    clienteReferenciaID: number;
    clienteID: number;
    descripcion: string;
    valor?: string;
    tipo: string;
    tipoNumerico: string;
    longitud: number;
    index: number;
}

export interface IClienteReferenciaCatalogo {
    clienteID: number;
    clienteReferenciaID: number;
    descripcion: string;
    longitud: number;
    tipoDato: {
        nombre: string;
    };
}

export function mapClienteReferenciaCatalogo(
    items: IClienteReferenciaCatalogo[]
): IGuiaClienteReferencia[] {
    return items.map((s, i) => ({
        tipo: s.tipoDato.nombre,
        tipoNumerico: s.tipoDato.nombre.charAt(0) + s.longitud,
        longitud: s.longitud,
        descripcion: s.descripcion,
        clienteID: s.clienteID,
        clienteReferenciaID: s.clienteReferenciaID,
        valor: '',
        index: i
    }));
}
